const isIos = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

export const getWidth = () =>
  isIos() ? window.screen.width : window.innerWidth;

export const getHeight = () =>
  isIos() ? window.screen.height : window.innerHeight;
